module.exports = __webpack_public_path__ + "img/streamingevents-dark.98c01831.svg";